<template>
  <div class="traffic-container">
    <div class="t_container">
      <div class="traffic_item_wrap" :class="{'active_traffic_item_wrap':currentWay==0}"  @click="currentWay=0">
        <div class="media_font_size_50">{{ $t("transportation.metro") }}</div>
      </div>
      <div class="traffic_item_wrap" :class="{'active_traffic_item_wrap':currentWay==1}"  @click="currentWay=1">
        <div class="media_font_size_50" >{{ $t("transportation.taxi") }}</div>
      </div>
      <div class="traffic_item_wrap" :class="{'active_traffic_item_wrap':currentWay==2}"  @click="currentWay=2">
        <div class="media_font_size_50">{{ $t("transportation.driving") }}</div>
      </div>
    </div>
    <div class="traffic_content">
      <p
        class="media_font_size_50"
        v-html="_i18n.locale == 'zh' ? metroContent.zh : metroContent.en"
        v-if="currentWay == 0"
      ></p>
      <p
        class="media_font_size_50"
        v-html="_i18n.locale == 'zh' ? taxiConent.zh : taxiConent.en"
        v-if="currentWay == 1"
      ></p>
      <div class="drive" v-if="currentWay == 2">
        <div class="dContent"><p>{{ $t("transportation.para1") }}</p><p>{{ $t("transportation.para2") }}</p><div style="text-align: center; padding-bottom: 20px;"><a href="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/static/img/201905230416241624669.jpg"><img title="从东面自驾车" border="0" src="https://cmsfile.cantonfair.org.cn/fileserver/booking/2019-05/201905230416241624669_b.jpg"></a><br>{{ $t("transportation.para3") }}<br></div><p>{{ $t("transportation.para4") }}</p><div style="text-align: center; padding-bottom: 20px;"><a href="https://cmsfile.cantonfair.org.cn/fileserver/booking/2019-05/20190523041709179385.jpg"><img title="从南面自驾车" border="0" src="https://cmsfile.cantonfair.org.cn/fileserver/booking/2019-05/20190523041709179385_b.jpg"></a><br>{{ $t("transportation.para5") }}<br></div><p>{{ $t("transportation.para6") }}</p><div style="text-align: center; padding-bottom: 20px;"><a href="https://cmsfile.cantonfair.org.cn/fileserver/booking/2019-05/201905230417551755516.jpg"><img title="从西面自驾车" border="0" src="https://cmsfile.cantonfair.org.cn/fileserver/booking/2019-05/201905230417551755516_b.jpg"></a><br>{{ $t("transportation.para7") }}<br></div><p>{{ $t("transportation.para8") }}</p><div style="text-align: center; padding-bottom: 20px;"><a href="https://cmsfile.cantonfair.org.cn/fileserver/booking/2019-05/20190523041900190468.jpg"><img title="从北面自驾车" border="0" src="https://cmsfile.cantonfair.org.cn/fileserver/booking/2019-05/20190523041900190468_b.jpg"></a><br>{{ $t("transportation.para9") }}<br></div><p>{{ $t("transportation.para10") }} </p></div>
      </div>
      <!-- <p
        class="media_font_size_50"
        v-if="currentWay == 2"
      >
      
    </p> -->
    </div>
    <!-- <div class="traffic_item mb_80">
      <div class="traffic_type">
          <div>1</div>
          <p class="flex-container">
            <span class="media_font_size_50">{{ $t("transportation.subway") }}</span>
          </p>
      </div>
      <el-table :data="metroList" border  style="width: 100%;" header-cell-class-name="header-row" :cell-style="{textAlign: 'center'}">
        <el-table-column prop="line" :label="$t('transportation.subwayroute')"></el-table-column>
        <el-table-column prop="station" :label="$t('transportation.destination')"></el-table-column>
        <el-table-column prop="start" :label="$t('transportation.allline')"></el-table-column>
        <el-table-column prop="time" :label="$t('transportation.lineMetro')"></el-table-column>
        <el-table-column prop="fee" :label="$t('transportation.fullfare')"></el-table-column>
      </el-table>
    </div>
    <div class="traffic_item">
      <div class="traffic_type">
          <div>2</div>
          <p class="flex-container">
            <span class="media_font_size_50">{{ $t("transportation.bus") }}</span>
          </p>
      </div>
      <el-table :data="busList" border header-cell-class-name="header-row" :cell-style="{textAlign: 'center'}">
        <el-table-column prop="line" :label="$t('transportation.busroute')" ></el-table-column>
        <el-table-column prop="station" :label="$t('transportation.destination')"></el-table-column>
        <el-table-column prop="start" :label="$t('transportation.allline')"></el-table-column>
        <el-table-column prop="time"  :label="$t('transportation.lineBus')"></el-table-column>
        <el-table-column prop="fee" :label="$t('transportation.fullfare')"></el-table-column>
      </el-table>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentWay: 0,
      taxiConent: {
        zh: `出租车是广州公共交通的重要组成部分，方便快捷,扬手即停，按表收费。<br>
广州市政府规定：除按表支付租金外，若行程需要经行额外收费路段，乘客还需额外支付期间所产生的高速公路通行费和过桥费等相关费用。<br>
电召出租车电话：96900<br>
温馨提示：出租车只能在展馆A区的展场中路出租车上客通道和展馆C区展馆东侧上客点上落客，其他路段不允许上落客。<br>
 

展场中路出租车上客区停靠时间（A、B馆中间路段靠近展场南路）<br>

C馆出租车临时上客点（C馆东侧会展南三路中间路段）<br>

机场搭乘出租车至广交会：<br>

广州白云国际机场的交通十分便利，沿机场高速公路由广交会展馆往白云机场大约1小时。坐出租车来往白云机场应该是目前最为方便的选择，但费用较为昂贵。<br>

火车站搭乘出租车至广交会：<br>

广州火车站至广交会展馆全程约17公里。<br>

广州火车东站至广交会展馆全程约10公里。<br>

广州火车南站至广交会展馆全程约29公里。<br>
以上信息仅供参考，请以交通部门最终发布为准。
`,
        en: `As an important part of Guangzhou's public transportation system, taxis offer fast and convenient service.<br>

The boarding time of Exhibition Road (A, B Hall MiddleRoad near the Exhibition Road)<br>

Canton Fair Complex pickup zone<br>
Taxis are not allowed to pick up passengers in any other regions except<br>
Area A & Area B:Complex Mid. Road<br>
Area C:at the east side of Complex AreaArea C.<br>

From Guangzhou Baiyun Airport to Canton Fair Complex<br>
Guangzhou Baiyun International Airport enjoys a great transportation network. It takes about 1 hour to drive along the Airport Express Way from the Complex to the Airport. Taxi should be the most convenient, and yet more expensive, way to go to the airport.<br>

Railway Stations to Canton Fair Complex<br>
It will take 38 minutes to cover the 17 Km between Guangzhou Railway Station and Canton Fair Complex.<br>
It will take 33 minutes to cover the 10 Km between Guangzhou East Railway Station and Canton Fair Complex.<br>
It will take 43 minutes to cover the 29 Km between Guangzhou South Railway Station and Canton Fair Complex.<br>
(Waiting time, traffic jam, and some other factors are not taken into consideration here)<br>

The above information is for reference only.`,
      },
      metroContent: {
        zh: `地铁8号线经过广交会展馆。乘坐地铁，从地铁新港东站A出入口可到广交会展馆A区、D区，或者从地铁琶洲站的A、B出入口可到广交会展馆B区，也可以在地铁琶洲站C出入口向西步行300米到广交会展馆C区。您可以就近乘坐地铁到广交会展馆。<br>

路线一：机场南站---新港东/琶洲站<br>

1、3号线（北延长线）机场北/机场南站 - 体育西路站，可转乘3号线 体育西路站 - 客村站，可转乘8号线客村站 - 新港东站（广交会展馆A区、D区）/琶洲站（广交会展馆B区和C区）<br>

2、3号线（北延长线）机场北/机场南-客村站，可转乘8号线客村站-新港东站（广交会展馆A区、D区）/琶洲站（广交会展馆B区和C区）<br>

时间：约43分钟，票价约：8元<br>


线路二：火车站到广交会展馆<br>


1、从广州火车站：乘坐地铁2号线（广州南站方向）至昌岗站，换8号线（万胜围站方向），在新港东站出口（A区、D区）或琶洲站（B区或C）。<br>

2、从广州火车东站：乘坐地铁3号线（番禺广场站方向）到客村站，换8号线（万胜围站方向），在新港东站出口（A区、D区）或琶洲站（B或C区）。<br>

3、从广州南站：乘坐地铁2号线（嘉禾望岗站方向）至昌岗站，换8号线（万胜围站方向），并在新港东路站（可到展馆A区、D区）或琶洲站（可到展馆B区和C区）下车。<br>

以上信息仅供参考。`,
        en: `Metro Line 8 passes Canton Fair Complex. Take metro from Exit A of Metro Xingangdong Station to Section A of the fair complex, or from Exit A or Exit B of Metro Pazhou Station to Section B of Fair Complex, or westward approximately 300 meters from Exit C of Pazhou Station to Section C of Fair Complex. You may take Metro at your convenience to Canton Fair Complex.<br>

Route:Jichang Nan Station ---Xinguang Dong/Pazhou Station<br>

Line 3 (North extended line) Jichang Nan Station --Tiyu Xi Station <br>
                           transfer<br>
Line 3   Tiyu Xi Station ---Kecun Station<br>
                           transfer<br>
Line 8   Kecun Station--Xingang Dong Station (Area A & D of Canton Fair Complex)<br>
                                       Pazhou Station (Area B & C of Canton Fair Complex)<br>

Duration: about 43 minutes; Fare: 8 Yuan<br>

Railway Stations to Canton Fair Complex<br>

From Guangzhou Railway Station: Take Metro Line 2 (in the direction of Guangzhou Nan Station) to Changgang Station, change to Line 8 (in the direction of Wansheng Wei Station) , and exit at Xingang Dong Station (for Area A & D) or Pazhou Station (for Area B & C).<br>

From Guangzhou East Railway Station: Take Metro Line 3 (in the direction of Panyu Square Station) to Kecun Station, change to Line 8 (in the direction of Wansheng Wei Station) , and exit at Xingang Dong Station (for Area A & D) or Pazhou Station (for Area B & C).<br>

From Guangzhou South Railway Station: Take Metro Line 2 (in the direction of Jiahe Wanggang Station) to Changgang Station, change to Line 8 (in the direction of Wansheng Wei Station) , and exit at Xingang Dong Station (for Area A & D) or Pazhou Station (for Area B & C).<br>

Metro to Canton Fair<br>


The above information is for reference only.`,
      },
      metroList: [
        {
          line: "8号",
          station: "新港东、琶洲",
          start: "凤凰新村←→万胜围",
          time: "06:15-22:40",
          fee: "6元",
        },
      ],
      busList: [
        {
          line: "137",
          station: "琶洲、琶洲大桥南",
          start: "动物园南门(总站)←→新洲总站",
          time: "06:15-21:45",
          fee: "2元",
        },
        {
          line: "139",
          station: "琶洲、国际会展中心",
          start: "东圃客运站(总站)←→海珠客运站总站",
          time: "06:15-22:00",
          fee: "3元",
        },
        {
          line: "20",
          station: "琶洲、琶洲大桥南、国际会展中心",
          start: "岑村教练场总站←→赤岗大塘(总站)",
          time: "06:00-22:00",
          fee: "2元",
        },
        {
          line: "229",
          station: "琶洲、琶洲大桥南、国际会展中心",
          start: "罗冲围总站←→琶洲石基村总站",
          time: "06:00-22:00",
          fee: "2元",
        },
        {
          line: "262",
          station: "琶洲、琶洲大桥南、国际会展中心",
          start: "赤岗东(总站) ←→ 新洲总站",
          time: "05:50-22:30",
          fee: "2元",
        },
        {
          line: "507",
          station: "琶洲、琶洲大桥南、国际会展中心",
          start: "大学城总站←→黄埔区政府",
          time: "06:00-21:30",
          fee: "3元",
        },
        {
          line: "564",
          station: "琶洲、琶洲大桥南",
          start: "琶洲黄埔村总站←→天河客运站(总站)",
          time: "06:30-21:30",
          fee: "4元",
        },
        {
          line: "583",
          station: "琶洲、琶洲大桥南、国际会展中心",
          start: "逸景翠园总站←→车陂(总站)",
          time: "06:30-21:00",
          fee: "2元",
        },
        {
          line: "92",
          station: "琶洲、国际会展中心",
          start: "广州火车东站总站←→江海大道中",
          time: "06:30-22:00",
          fee: "2元",
        },
        {
          line: "大学城3线",
          station: "琶洲、琶洲大桥南、国际会展中心",
          start: "大学城总站←→广东药学院总站",
          time: "07:30-22:00",
          fee: "3元",
        },
        {
          line: "505",
          station: "琶洲、琶洲大桥南、国际会展中心",
          start: "塘村总站←→珠江泳场总站",
          time: "06:30-21:30",
          fee: "3元",
        },
      ],
    };
  },
  methods: {
    tableHeadClassName({ row, rowIndex }) {
      console.log(row, rowIndex);
      return "head-row";
    },
    handelPre() {},
    handelNext() {},
    handelJump(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss">
.traffic-container {
  width: 100%;
  .t_container {
    display: flex;
    justify-content: space-between;
    .traffic_item_wrap {
      width: 220px;
      height: 80px;
      cursor: pointer;
      // flex: 1;
      background: #39363c;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 24px;
      margin-bottom: 20px;
      border-radius: 20px;
    }
    .active_traffic_item_wrap {
      background: #42abff;
      color: #fff;
    }

  }

  .traffic_item {
    .traffic_type {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      > div {
        min-width: 36px;
        // min-height: 36px;
        padding: 15px;
        border-radius: 50%;
        box-sizing: border-box;
        background: #e16a13;
        color: #fff;
        margin-right: 17px;
        text-align: center;
        font-weight: bold;
        // line-height: 36px;
      }
      > span {
        font-size: 20px;
        color: #fff;
      }
      > p {
        font-size: 14px;
        margin: 0;
      }
    }
  }
  .desc_wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #fff;
    margin-bottom: 102px;
    > span {
      color: rgba($color: #fff, $alpha: 0.5);
      font-size: 24px;
    }
  }
}

.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  > h2 {
    font-size: 36px;
  }
  > span {
    color: rgba($color: #fff, $alpha: 0.5);
  }
}
.default_btn {
  background: rgba($color: #fff, $alpha: 0.2);
  border-radius: 30px;
  padding: 18px;
  width: 300px;
  text-align: center;
  color: rgba($color: #fff, $alpha: 0.5);
  font-size: 24px;
  margin: 60px auto;
}
.mb_80 {
  margin-bottom: 80px;
}
.header-row {
  background: #42abff !important;
  color: #fff;
  text-align: center !important;
}
.traffic_content {
  > p {
    font-size: 23px;
    line-height: 42px;
  }
}

.drive{
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  font-size: 23px;
  img{
    width: 400px;
    height: 300px;
  }
}

.dContent{
  line-height: 42px;
  p{
    margin:0 !important;
  }
}

@media screen and (max-width: 1000px) {
  .traffic-container {
    width: 100vw;
  }
}
</style>



// WEBPACK FOOTER //
// traffic.vue?114b9bea